import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemApplicationViewRoute: InvariantJiraRoute = {
	name: 'global-settings-system-application-view',
	path: '/secure/admin/ViewApplicationProperties.jspa',
};
